export const SET_STORE_DETAIL = 'SET_STORE_DETAIL';
export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const SET_GUEST_USER_PROFILE = 'SET_GUEST_USER_PROFILE';
export const SET_COUNTRIES_INFO ='SET_COUNTRIES_INFO';
export const SET_STORES_INFO = 'SET_STORES_INFO';
export const SET_GUEST_CART = 'SET_GUEST_CART';
export const SET_STORE = 'SET_STORE';

export default {
  SET_STORE_DETAIL,
  SET_USER_PROFILE,
  SET_GUEST_USER_PROFILE,
  SET_COUNTRIES_INFO,
  SET_STORES_INFO,
  SET_GUEST_CART,
  SET_STORE
};



// WEBPACK FOOTER //
// ./src/app/auth/action-types.js